"use client";

import { useId, useState } from "react";

type Props = {
  id?: string;
  name: string;
  autoComplete?: string;
  required?: boolean;
  minLength?: number;
  defaultValue?: string;
  className?: string;
  showLabel: string;
  hideLabel: string;
};

export function PasswordInput({
  id,
  name,
  autoComplete,
  required,
  minLength,
  defaultValue,
  className = "w-full rounded-md border border-stone-300 bg-white px-3 py-2 pr-11 text-stone-900",
  showLabel,
  hideLabel,
}: Props) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <input
        id={inputId}
        name={name}
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
        defaultValue={defaultValue}
        className={className}
      />
      <button
        type="button"
        onClick={() => setVisible((value) => !value)}
        aria-pressed={visible}
        aria-label={visible ? hideLabel : showLabel}
        title={visible ? hideLabel : showLabel}
        className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-stone-500 hover:text-stone-800"
      >
        {visible ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
}

function EyeIcon() {
  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      className="h-5 w-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 12s3.75-6.75 9.75-6.75S21.75 12 21.75 12s-3.75 6.75-9.75 6.75S2.25 12 2.25 12Z"
      />
      <circle cx="12" cy="12" r="2.75" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg
      aria-hidden
      viewBox="0 0 24 24"
      className="h-5 w-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 3l18 18M9.9 9.9A2.75 2.75 0 0 0 12 14.75m7.66-2.1c.55-.53.89-.9.89-.9s-3.75-6.75-9.75-6.75c-1.16 0-2.24.24-3.23.64M6.1 6.1C4.05 7.4 2.25 12 2.25 12s3.75 6.75 9.75 6.75c1.86 0 3.5-.47 4.9-1.2"
      />
    </svg>
  );
}
